import { Columns } from '@shared/interfaces/table/column-config';

export const customerInformationMasterData: Columns<any>[] = [
  {
    key: 'customer1',
    title: 'Kunde 1',
  },
  {
    key: 'cvr1',
    title: "CVR 1",
  },
  {
    key: 'customer2',
    title: 'Kunde 2',
  },
  {
    key: 'cvr2',
    title: "CVR 2",
  },
  {
    key: 'protectedAddress',
    title: 'Hemmelig adresse',
  }
];
